import type { EnemyConfig } from '../../entities/EnemyConfig';

export const DEER_CONFIG: EnemyConfig = {
  id: 'deer',
  displayName: 'Олень',
  maxHp: 8,
  speed: 70,
  speedHpMultiplier: 2.75,
  movementBehavior: 'chase',
  size: 45,
  color: 0x8b5a2b,
  scoreReward: 25,
};
